import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Paper,
  Alert,
  Typography,
  Checkbox,
  TextField,
} from "@mui/material";
import { Tabs } from "@mui/base/Tabs";
import { TabsList } from "@mui/base/TabsList";
import { Tab } from "@mui/base/Tab";
import LoginTabContent from "./LoginTabContent";

import { COLORS } from "../../utils/colors";
import "./loginSettings.css";

const LoginSettings = ({
  modalVisible,
  handleCloseModal,
  savedSettings,
  setSavedSettings,
}) => {
  let socialSubmissionSettings = savedSettings;

  // Tab state
  const [activeTab, setActiveTab] = useState("social-submissions");
  const [validationErrors, setValidationErrors] = useState([]);

  // Common Terms of Use states (shared across all tabs)
  const [enableTermsOfUse, setEnableTermsOfUse] = useState(
    savedSettings?.enableTermsOfUse || false
  );
  const [termsOfUseURL, setTermsOfUseURL] = useState(
    savedSettings?.termsOfUseURL || ""
  );
  const [termsDescription, setTermsDescription] = useState(
    savedSettings?.termsDescription || ""
  );

  // Terms of Use Consent checkbox
  const [termsConsentEnabled, setTermsConsentEnabled] = useState(
    savedSettings?.termsConsentEnabled || false
  );
  const [termsConsentText, setTermsConsentText] = useState(
    savedSettings?.termsConsentText || ""
  );

  // Social Submissions states
  const [requireNameSocial, setRequireNameSocial] = useState(
    savedSettings ? savedSettings.requireNameSocial : true
  );
  const [requireEmailSocial, setRequireEmailSocial] = useState(
    savedSettings ? savedSettings.requireEmailSocial : false
  );
  const [requireAgeSocial, seRequireAgeSocial] = useState(
    savedSettings ? savedSettings.requireAgeSocial : false
  );
  const [requirePhoneSocial, setRequirePhoneSocial] = useState(
    savedSettings ? savedSettings.requirePhoneSocial : false
  );
  const [requireAddressSocial, setRequireAddressSocial] = useState(
    savedSettings ? savedSettings.requireAddressSocial : false
  );
  const [mustBe18AndOlderSocial, setMustBe18AndOlderSocial] = useState(
    savedSettings ? savedSettings.mustBe18AndOlderSocial : false
  );
  const [mustBe21AndOlderSocial, setMustBe21AndOlderSocial] = useState(
    savedSettings ? savedSettings.mustBe21AndOlderSocial : false
  );

  // Social consent states
  const [nameConsentEnabledSocial, setNameConsentEnabledSocial] = useState(
    savedSettings?.nameConsentEnabledSocial || false
  );
  const [nameConsentTextSocial, setNameConsentTextSocial] = useState(
    savedSettings?.nameConsentTextSocial || ""
  );
  const [emailConsentEnabledSocial, setEmailConsentEnabledSocial] = useState(
    savedSettings?.emailConsentEnabledSocial || false
  );
  const [emailConsentTextSocial, setEmailConsentTextSocial] = useState(
    savedSettings?.emailConsentTextSocial || ""
  );
  const [ageConsentEnabledSocial, setAgeConsentEnabledSocial] = useState(
    savedSettings?.ageConsentEnabledSocial || false
  );
  const [ageConsentTextSocial, setAgeConsentTextSocial] = useState(
    savedSettings?.ageConsentTextSocial || ""
  );

  // Live User Camera states
  const [requireNameLiveCam, setRequireNameLiveCam] = useState(
    savedSettings ? savedSettings.requireNameLiveCam : true
  );
  const [requireEmailLiveCam, setRequireEmailLiveCam] = useState(
    savedSettings ? savedSettings.requireEmailLiveCam : false
  );
  const [requireAgeLiveCam, setRequireAgeLiveCam] = useState(
    savedSettings ? savedSettings.requireAgeLiveCam : false
  );
  const [requirePhoneLiveCam, setRequirePhoneLiveCam] = useState(
    savedSettings ? savedSettings.requirePhoneLiveCam : false
  );
  const [requireAddressLiveCam, setRequireAddressLiveCam] = useState(
    savedSettings ? savedSettings.requireAddressLiveCam : false
  );
  const [mustBe18AndOlderLiveCam, setMustBe18AndOlderLiveCam] = useState(
    savedSettings ? savedSettings.mustBe18AndOlderLiveCam : false
  );
  const [mustBe21AndOlderLiveCam, setMustBe21AndOlderLiveCam] = useState(
    savedSettings ? savedSettings.mustBe21AndOlderLiveCam : false
  );

  // Live Camera consent states
  const [nameConsentEnabledLiveCam, setNameConsentEnabledLiveCam] = useState(
    savedSettings?.nameConsentEnabledLiveCam || false
  );
  const [nameConsentTextLiveCam, setNameConsentTextLiveCam] = useState(
    savedSettings?.nameConsentTextLiveCam || ""
  );
  const [emailConsentEnabledLiveCam, setEmailConsentEnabledLiveCam] = useState(
    savedSettings?.emailConsentEnabledLiveCam || false
  );
  const [emailConsentTextLiveCam, setEmailConsentTextLiveCam] = useState(
    savedSettings?.emailConsentTextLiveCam || ""
  );
  const [ageConsentEnabledLiveCam, setAgeConsentEnabledLiveCam] = useState(
    savedSettings?.ageConsentEnabledLiveCam || false
  );
  const [ageConsentTextLiveCam, setAgeConsentTextLiveCam] = useState(
    savedSettings?.ageConsentTextLiveCam || ""
  );

  // Polling/Gaming states
  const [requireNameGames, setRequireNameGames] = useState(
    savedSettings ? savedSettings.requireNameGames : true
  );
  const [requireEmailGames, setRequireEmailGames] = useState(
    savedSettings ? savedSettings.requireEmailGames : false
  );
  const [requireAgeGames, setRequireAgeGames] = useState(
    savedSettings ? savedSettings.requireAgeGames : false
  );
  const [requirePhoneGames, setRequirePhoneGames] = useState(
    savedSettings ? savedSettings.requirePhoneGames : false
  );
  const [requireAddressGames, setRequireAddressGames] = useState(
    savedSettings ? savedSettings.requireAddressGames : false
  );
  const [mustBe18AndOlderGames, setMustBe18AndOlderGames] = useState(
    savedSettings ? savedSettings.mustBe18AndOlderGames : false
  );
  const [mustBe21AndOlderGames, setMustBe21AndOlderGames] = useState(
    savedSettings ? savedSettings.mustBe21AndOlderGames : false
  );

  // Games consent states
  const [nameConsentEnabledGames, setNameConsentEnabledGames] = useState(
    savedSettings?.nameConsentEnabledGames || false
  );
  const [nameConsentTextGames, setNameConsentTextGames] = useState(
    savedSettings?.nameConsentTextGames || ""
  );
  const [emailConsentEnabledGames, setEmailConsentEnabledGames] = useState(
    savedSettings?.emailConsentEnabledGames || false
  );
  const [emailConsentTextGames, setEmailConsentTextGames] = useState(
    savedSettings?.emailConsentTextGames || ""
  );
  const [ageConsentEnabledGames, setAgeConsentEnabledGames] = useState(
    savedSettings?.ageConsentEnabledGames || false
  );
  const [ageConsentTextGames, setAgeConsentTextGames] = useState(
    savedSettings?.ageConsentTextGames || ""
  );

  // Light Show states
  const [requireNameLightShow, setRequireNameLightShow] = useState(
    savedSettings ? savedSettings.requireNameLightShow : true
  );
  const [requireEmailLightShow, setRequireEmailLightShow] = useState(
    savedSettings ? savedSettings.requireEmailLightShow : false
  );
  const [requireAgeLightShow, setRequireAgeLightShow] = useState(
    savedSettings ? savedSettings.requireAgeLightShow : false
  );
  const [requirePhoneLightShow, setRequirePhoneLightShow] = useState(
    savedSettings ? savedSettings.requirePhoneLightShow : false
  );
  const [requireAddressLightShow, setRequireAddressLightShow] = useState(
    savedSettings ? savedSettings.requireAddressLightShow : false
  );
  const [mustBe18AndOlderLightShow, setMustBe18AndOlderLightShow] = useState(
    savedSettings ? savedSettings.mustBe18AndOlderLightShow : false
  );
  const [mustBe21AndOlderLightShow, setMustBe21AndOlderLightShow] = useState(
    savedSettings ? savedSettings.mustBe21AndOlderLightShow : false
  );

  // Light Show consent states
  const [nameConsentEnabledLightShow, setNameConsentEnabledLightShow] = useState(
    savedSettings?.nameConsentEnabledLightShow || false
  );
  const [nameConsentTextLightShow, setNameConsentTextLightShow] = useState(
    savedSettings?.nameConsentTextLightShow || ""
  );
  const [emailConsentEnabledLightShow, setEmailConsentEnabledLightShow] = useState(
    savedSettings?.emailConsentEnabledLightShow || false
  );
  const [emailConsentTextLightShow, setEmailConsentTextLightShow] = useState(
    savedSettings?.emailConsentTextLightShow || ""
  );
  const [ageConsentEnabledLightShow, setAgeConsentEnabledLightShow] = useState(
    savedSettings?.ageConsentEnabledLightShow || false
  );
  const [ageConsentTextLightShow, setAgeConsentTextLightShow] = useState(
    savedSettings?.ageConsentTextLightShow || ""
  );

  // Validation function
  const validateSettings = () => {
    const errors = [];

    // Helper function to validate URL format
    const isValidURL = (url) => {
      try {
        new URL(url);
        return true;
      } catch (error) {
        return false;
      }
    };

    // Helper function to check tab validation (without Terms of Use)
    const validateTab = (tabName, requireAge, mustBe18, mustBe21) => {
      if (requireAge) {
        if (!mustBe18 && !mustBe21) {
          errors.push(
            `${tabName}: If age is required, you must select at least one age restriction (18+ or 21+)`
          );
        }
      }
    };

    // Validate all tabs (without Terms of Use)
    validateTab(
      "Social Submissions",
      requireAgeSocial,
      mustBe18AndOlderSocial,
      mustBe21AndOlderSocial
    );
    validateTab(
      "Live User Camera",
      requireAgeLiveCam,
      mustBe18AndOlderLiveCam,
      mustBe21AndOlderLiveCam
    );
    validateTab(
      "Polling/Gaming",
      requireAgeGames,
      mustBe18AndOlderGames,
      mustBe21AndOlderGames
    );
    validateTab(
      "Light Show",
      requireAgeLightShow,
      mustBe18AndOlderLightShow,
      mustBe21AndOlderLightShow
    );

    // Validate common Terms of Use
    if (enableTermsOfUse) {
      if (!termsOfUseURL || termsOfUseURL.trim() === "") {
        errors.push(
          "Terms of Use URL is required when Terms of Use is enabled"
        );
      } else if (!isValidURL(termsOfUseURL.trim())) {
        errors.push(
          "Terms of Use URL must be a valid URL (e.g., https://example.com)"
        );
      }
      if (!termsDescription || termsDescription.trim() === "") {
        errors.push(
          "Terms Description is required when Terms of Use is enabled"
        );
      }
    }

    return errors;
  };

  const handleDoneClick = () => {
    const errors = validateSettings();

    if (errors.length > 0) {
      setValidationErrors(errors);
      return;
    }

    // Clear any previous errors
    setValidationErrors([]);

    // Update settings with common Terms of Use
    socialSubmissionSettings.enableTermsOfUse = enableTermsOfUse;
    socialSubmissionSettings.termsOfUseURL = termsOfUseURL;
    socialSubmissionSettings.termsDescription = termsDescription;
    socialSubmissionSettings.termsConsentEnabled = termsConsentEnabled;
    socialSubmissionSettings.termsConsentText = termsConsentText;

    // Save all consent settings for each tab
    // Social consent settings
    socialSubmissionSettings.nameConsentEnabledSocial = nameConsentEnabledSocial;
    socialSubmissionSettings.nameConsentTextSocial = nameConsentTextSocial;
    socialSubmissionSettings.emailConsentEnabledSocial = emailConsentEnabledSocial;
    socialSubmissionSettings.emailConsentTextSocial = emailConsentTextSocial;
    socialSubmissionSettings.ageConsentEnabledSocial = ageConsentEnabledSocial;
    socialSubmissionSettings.ageConsentTextSocial = ageConsentTextSocial;

    // Live Camera consent settings
    socialSubmissionSettings.nameConsentEnabledLiveCam = nameConsentEnabledLiveCam;
    socialSubmissionSettings.nameConsentTextLiveCam = nameConsentTextLiveCam;
    socialSubmissionSettings.emailConsentEnabledLiveCam = emailConsentEnabledLiveCam;
    socialSubmissionSettings.emailConsentTextLiveCam = emailConsentTextLiveCam;
    socialSubmissionSettings.ageConsentEnabledLiveCam = ageConsentEnabledLiveCam;
    socialSubmissionSettings.ageConsentTextLiveCam = ageConsentTextLiveCam;

    // Games consent settings
    socialSubmissionSettings.nameConsentEnabledGames = nameConsentEnabledGames;
    socialSubmissionSettings.nameConsentTextGames = nameConsentTextGames;
    socialSubmissionSettings.emailConsentEnabledGames = emailConsentEnabledGames;
    socialSubmissionSettings.emailConsentTextGames = emailConsentTextGames;
    socialSubmissionSettings.ageConsentEnabledGames = ageConsentEnabledGames;
    socialSubmissionSettings.ageConsentTextGames = ageConsentTextGames;

    // Light Show consent settings
    socialSubmissionSettings.nameConsentEnabledLightShow = nameConsentEnabledLightShow;
    socialSubmissionSettings.nameConsentTextLightShow = nameConsentTextLightShow;
    socialSubmissionSettings.emailConsentEnabledLightShow = emailConsentEnabledLightShow;
    socialSubmissionSettings.emailConsentTextLightShow = emailConsentTextLightShow;
    socialSubmissionSettings.ageConsentEnabledLightShow = ageConsentEnabledLightShow;
    socialSubmissionSettings.ageConsentTextLightShow = ageConsentTextLightShow;

    // Save settings and close modal
    setSavedSettings(socialSubmissionSettings);
    handleCloseModal();
  };

  return (
    <Dialog
      maxWidth="lg"
      open={modalVisible}
      scroll="paper"
      onClose={handleCloseModal}
    >
      <Paper
        style={{ backgroundColor: COLORS.popupBackground, minWidth: "600px" }}
      >
        <DialogTitle style={{ color: COLORS.textHeader }}>
          Web App Login Settings
        </DialogTitle>
        <DialogContent>
          {/* Display validation errors */}
          {validationErrors.length > 0 && (
            <Alert severity="error" style={{ marginBottom: "16px" }}>
              <div>
                <strong>Please fix the following errors:</strong>
                <ul style={{ marginTop: "8px", marginBottom: "0" }}>
                  {validationErrors.map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            </Alert>
          )}

          <Tabs
            value={activeTab}
            onChange={(event, value) => setActiveTab(value)}
            className="w-full mb-4"
          >
            <TabsList className="w-full inline-flex h-10 items-center justify-between rounded-md bg-muted p-1 text-muted-foreground bg-gray-800/50 rounded-lg">
              <Tab
                value="social-submissions"
                className={`${
                  activeTab === "social-submissions"
                    ? "selected loginSettingsTab"
                    : "loginSettingsTab"
                }`}
              >
                Social Submissions
              </Tab>
              <Tab
                value="live-user-camera"
                className={`${
                  activeTab === "live-user-camera"
                    ? "selected loginSettingsTab"
                    : "loginSettingsTab"
                }`}
              >
                Live User Camera
              </Tab>
              <Tab
                value="polling-gaming"
                className={`${
                  activeTab === "polling-gaming"
                    ? "selected loginSettingsTab"
                    : "loginSettingsTab"
                }`}
              >
                Polling/Gaming
              </Tab>
              {/* <Tab
                value="light-show"
                className={`${
                  activeTab === "light-show"
                    ? "selected loginSettingsTab"
                    : "loginSettingsTab"
                }`}
              >
                Light Show
              </Tab> */}
            </TabsList>

            {/* Social Submissions Tab Content */}
            {activeTab === "social-submissions" && (
              <LoginTabContent
                suffix="Social"
                tabType="social-submissions"
                requireName={requireNameSocial}
                setRequireName={setRequireNameSocial}
                requireEmail={requireEmailSocial}
                setRequireEmail={setRequireEmailSocial}
                requireAge={requireAgeSocial}
                setRequireAge={seRequireAgeSocial}
                requirePhone={requirePhoneSocial}
                setRequirePhone={setRequirePhoneSocial}
                requireAddress={requireAddressSocial}
                setRequireAddress={setRequireAddressSocial}
                mustBe18AndOlder={mustBe18AndOlderSocial}
                setMustBe18AndOlder={setMustBe18AndOlderSocial}
                mustBe21AndOlder={mustBe21AndOlderSocial}
                setMustBe21AndOlder={setMustBe21AndOlderSocial}
                settings={socialSubmissionSettings}
                hideTermsOfUse={true}
                // Consent props
                nameConsentEnabled={nameConsentEnabledSocial}
                setNameConsentEnabled={setNameConsentEnabledSocial}
                nameConsentText={nameConsentTextSocial}
                setNameConsentText={setNameConsentTextSocial}
                emailConsentEnabled={emailConsentEnabledSocial}
                setEmailConsentEnabled={setEmailConsentEnabledSocial}
                emailConsentText={emailConsentTextSocial}
                setEmailConsentText={setEmailConsentTextSocial}
                ageConsentEnabled={ageConsentEnabledSocial}
                setAgeConsentEnabled={setAgeConsentEnabledSocial}
                ageConsentText={ageConsentTextSocial}
                setAgeConsentText={setAgeConsentTextSocial}
              />
            )}

            {/* Live User Camera Tab Content */}
            {activeTab === "live-user-camera" && (
              <LoginTabContent
                suffix="LiveCam"
                tabType="live-user-camera"
                requireName={requireNameLiveCam}
                setRequireName={setRequireNameLiveCam}
                requireEmail={requireEmailLiveCam}
                setRequireEmail={setRequireEmailLiveCam}
                requireAge={requireAgeLiveCam}
                setRequireAge={setRequireAgeLiveCam}
                requirePhone={requirePhoneLiveCam}
                setRequirePhone={setRequirePhoneLiveCam}
                requireAddress={requireAddressLiveCam}
                setRequireAddress={setRequireAddressLiveCam}
                mustBe18AndOlder={mustBe18AndOlderLiveCam}
                setMustBe18AndOlder={setMustBe18AndOlderLiveCam}
                mustBe21AndOlder={mustBe21AndOlderLiveCam}
                setMustBe21AndOlder={setMustBe21AndOlderLiveCam}
                settings={socialSubmissionSettings}
                hideTermsOfUse={true}
                // Consent props
                nameConsentEnabled={nameConsentEnabledLiveCam}
                setNameConsentEnabled={setNameConsentEnabledLiveCam}
                nameConsentText={nameConsentTextLiveCam}
                setNameConsentText={setNameConsentTextLiveCam}
                emailConsentEnabled={emailConsentEnabledLiveCam}
                setEmailConsentEnabled={setEmailConsentEnabledLiveCam}
                emailConsentText={emailConsentTextLiveCam}
                setEmailConsentText={setEmailConsentTextLiveCam}
                ageConsentEnabled={ageConsentEnabledLiveCam}
                setAgeConsentEnabled={setAgeConsentEnabledLiveCam}
                ageConsentText={ageConsentTextLiveCam}
                setAgeConsentText={setAgeConsentTextLiveCam}
              />
            )}

            {/* Polling/Gaming Tab Content */}
            {activeTab === "polling-gaming" && (
              <LoginTabContent
                suffix="Games"
                tabType="polling-gaming"
                requireName={requireNameGames}
                setRequireName={setRequireNameGames}
                requireEmail={requireEmailGames}
                setRequireEmail={setRequireEmailGames}
                requireAge={requireAgeGames}
                setRequireAge={setRequireAgeGames}
                requirePhone={requirePhoneGames}
                setRequirePhone={setRequirePhoneGames}
                requireAddress={requireAddressGames}
                setRequireAddress={setRequireAddressGames}
                mustBe18AndOlder={mustBe18AndOlderGames}
                setMustBe18AndOlder={setMustBe18AndOlderGames}
                mustBe21AndOlder={mustBe21AndOlderGames}
                setMustBe21AndOlder={setMustBe21AndOlderGames}
                settings={socialSubmissionSettings}
                hideTermsOfUse={true}
                // Consent props
                nameConsentEnabled={nameConsentEnabledGames}
                setNameConsentEnabled={setNameConsentEnabledGames}
                nameConsentText={nameConsentTextGames}
                setNameConsentText={setNameConsentTextGames}
                emailConsentEnabled={emailConsentEnabledGames}
                setEmailConsentEnabled={setEmailConsentEnabledGames}
                emailConsentText={emailConsentTextGames}
                setEmailConsentText={setEmailConsentTextGames}
                ageConsentEnabled={ageConsentEnabledGames}
                setAgeConsentEnabled={setAgeConsentEnabledGames}
                ageConsentText={ageConsentTextGames}
                setAgeConsentText={setAgeConsentTextGames}
              />
            )}

            {/* Light Show Tab Content */}
            {activeTab === "light-show" && (
              <LoginTabContent
                suffix="LightShow"
                tabType="light-show"
                requireName={requireNameLightShow}
                setRequireName={setRequireNameLightShow}
                requireEmail={requireEmailLightShow}
                setRequireEmail={setRequireEmailLightShow}
                requireAge={requireAgeLightShow}
                setRequireAge={setRequireAgeLightShow}
                requirePhone={requirePhoneLightShow}
                setRequirePhone={setRequirePhoneLightShow}
                requireAddress={requireAddressLightShow}
                setRequireAddress={setRequireAddressLightShow}
                mustBe18AndOlder={mustBe18AndOlderLightShow}
                setMustBe18AndOlder={setMustBe18AndOlderLightShow}
                mustBe21AndOlder={mustBe21AndOlderLightShow}
                setMustBe21AndOlder={setMustBe21AndOlderLightShow}
                settings={socialSubmissionSettings}
                hideTermsOfUse={true}
                // Consent props
                nameConsentEnabled={nameConsentEnabledLightShow}
                setNameConsentEnabled={setNameConsentEnabledLightShow}
                nameConsentText={nameConsentTextLightShow}
                setNameConsentText={setNameConsentTextLightShow}
                emailConsentEnabled={emailConsentEnabledLightShow}
                setEmailConsentEnabled={setEmailConsentEnabledLightShow}
                emailConsentText={emailConsentTextLightShow}
                setEmailConsentText={setEmailConsentTextLightShow}
                ageConsentEnabled={ageConsentEnabledLightShow}
                setAgeConsentEnabled={setAgeConsentEnabledLightShow}
                ageConsentText={ageConsentTextLightShow}
                setAgeConsentText={setAgeConsentTextLightShow}
              />
            )}
          </Tabs>

          {/* Common Terms of Use Section */}
          <div
            style={{
              marginTop: "24px",
              paddingTop: "24px",
              borderTop: `1px solid ${COLORS.primary}`,
            }}
          >
            <Typography
              variant="h6"
              style={{ color: COLORS.textHeader, marginBottom: "16px" }}
            >
              Terms of Use (Common for All Tabs):
            </Typography>

            <div style={{ marginBottom: "16px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginBottom: "16px",
                }}
                onClick={() => {
                  setEnableTermsOfUse(!enableTermsOfUse);
                  socialSubmissionSettings["enableTermsOfUse"] =
                    !enableTermsOfUse;
                }}
              >
                <Checkbox
                  checked={enableTermsOfUse}
                  sx={{
                    color: COLORS.primary,
                    "&.Mui-checked": { color: COLORS.primary },
                  }}
                />
                <Typography
                  style={{
                    color: COLORS.textLabel,
                    fontSize: 14,
                    pointerEvents: "none",
                  }}
                >
                  Enable Terms of Use
                </Typography>
              </div>

              {enableTermsOfUse && (
                <>
                  <div style={{ marginBottom: "16px" }}>
                    <Typography
                      style={{
                        color: COLORS.textLabel,
                        fontSize: 14,
                        marginBottom: "8px",
                      }}
                    >
                      Terms of Use URL
                    </Typography>
                    <TextField
                      fullWidth
                      value={termsOfUseURL}
                      onChange={(e) => {
                        setTermsOfUseURL(e.target.value);
                        socialSubmissionSettings["termsOfUseURL"] = e.target.value;
                      }}
                      placeholder="https://example.com/terms"
                      variant="outlined"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: COLORS.popupBackground,
                          color: COLORS.textLabel,
                          "& fieldset": {
                            borderColor: COLORS.primary,
                          },
                          "&:hover fieldset": {
                            borderColor: COLORS.primary,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: COLORS.primary,
                          },
                        },
                      }}
                    />
                  </div>

                  <div>
                    <Typography
                      style={{
                        color: COLORS.textLabel,
                        fontSize: 14,
                        marginBottom: "8px",
                      }}
                    >
                      Terms Description
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      value={termsDescription}
                      onChange={(e) => {
                        setTermsDescription(e.target.value);
                        socialSubmissionSettings["termsDescription"] =
                          e.target.value;
                      }}
                      placeholder="Terms of Use description..."
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: COLORS.popupBackground,
                          color: COLORS.textLabel,
                          "& fieldset": {
                            borderColor: COLORS.primary,
                          },
                          "&:hover fieldset": {
                            borderColor: COLORS.primary,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: COLORS.primary,
                          },
                        },
                      }}
                    />
                  </div>

                  {/* Terms of Use Consent Section */}
                  <div style={{ marginTop: "16px" }}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        const newValue = !termsConsentEnabled;
                        setTermsConsentEnabled(newValue);
                        socialSubmissionSettings["termsConsentEnabled"] = newValue;
                        if (!newValue) {
                          // Clear consent text when disabling
                          setTermsConsentText("");
                          socialSubmissionSettings["termsConsentText"] = "";
                        }
                      }}
                      style={{
                        color: termsConsentEnabled ? COLORS.textHeader : COLORS.primary,
                        backgroundColor: termsConsentEnabled ? COLORS.primary : "transparent",
                        borderColor: COLORS.primary,
                        textTransform: "none",
                        fontSize: "12px",
                        padding: "4px 12px",
                        marginBottom: "12px",
                      }}
                    >
                      {termsConsentEnabled ? "Remove Consent Box" : "Add Consent Box"}
                    </Button>

                    {termsConsentEnabled && (
                      <div>
                        <Typography
                          style={{
                            color: COLORS.textLabel,
                            fontSize: 12,
                            marginBottom: "8px",
                          }}
                        >
                          Consent text for Terms of Use:
                        </Typography>
                        <TextField
                          fullWidth
                          multiline
                          rows={3}
                          value={termsConsentText}
                          onChange={(e) => {
                            setTermsConsentText(e.target.value);
                            socialSubmissionSettings["termsConsentText"] = e.target.value;
                          }}
                          placeholder="*I agree that my information may be used and shared by <company-name> and its affiliates as described in the Privacy Policy."
                          variant="outlined"
                          size="small"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: COLORS.popupBackground,
                              color: COLORS.textLabel,
                              fontSize: "12px",
                              "& fieldset": {
                                borderColor: COLORS.primary,
                              },
                              "&:hover fieldset": {
                                borderColor: COLORS.primary,
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: COLORS.primary,
                              },
                            },
                          }}
                        />
                        <Typography
                          style={{
                            color: COLORS.textLabel,
                            fontSize: 11,
                            marginTop: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          Note: "Privacy Policy" text will be automatically made clickable and linked to your Terms of Use URL.
                        </Typography>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            style={{
              backgroundColor: "transparent",
              color: COLORS.primary,
              borderColor: COLORS.primary,
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            style={{
              color: COLORS.textHeader,
              backgroundColor: COLORS.primary,
              borderColor: COLORS.primary,
            }}
            onClick={handleDoneClick}
          >
            Done
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  );
};

export default LoginSettings;
